<template>
  <div>
    <b-navbar
      class="px-5 py-0 nav_bar_flex bg-white"
      toggleable="lg"
      type="light"
      fixed="top"
    >
      <b-navbar-brand href="#">
        <p class="fs-18 t-red font-weight-bold mb-0">
          <img src="@/assets/img/main_logo.png" alt="" width="30" />
          Pre<span class="t-black font-weight-bold">Order.id</span>
        </p>
      </b-navbar-brand>
      <b-navbar-toggle
        v-b-toggle.sidebar-no-header-2
        target="nav-collapsex"
      ></b-navbar-toggle>

      <b-sidebar
        id="sidebar-no-header-2"
        aria-labelledby="sidebar-no-header-title"
        no-header
        shadow
      >
        <template v-slot:default="{ hide }">
          <div class="bg-white h-100">
            <div
              class="p-3 position-relative"
              style=" border-bottom: 1px solid #d6d2d2;"
            >
              <span
                class="fs-18 text-dark font-weight-bold mr-4 pointer position-absolute"
                @click="hide"
                style="right:0px; top:0px;"
                >X</span
              >
              <img
                class="rounded-circle d-inline-block align-middle mr-3"
                src="@/assets/img/people.png"
                alt=""
                width="70"
              />
              <div class="d-inline-block align-middle">
                <span class="fs-14 font-weight-bold mb-0">CINDY YUVIA /</span>
                <span class="t-s-grey fs-12 mb-0"><i>Verified account</i></span>
              </div>
            </div>

            <div class="col-md-12">
              <div class="position-relative">
                <input
                  type="text"
                  class="search_navbar w-100 px-3 fs-14"
                  placeholder="Cari mobil"
                />
                <div class="position-absolute wrapper_search text-center">
                  <b-icon icon="search"></b-icon>
                </div>
              </div>
              <div class="hot_item text-center">
                HOT ITEMS
              </div>
              <div
                class="hot_item text-center w-100 b-red border-0 text-white font-weight-bold my-3"
              >
                Logout
              </div>
            </div>
          </div>
        </template>
      </b-sidebar>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="w-100">
          <b-nav-item href="#" class="item_search">
            <div class="position-relative">
              <input
                type="text"
                class="search_navbar w-100 px-3 fs-14"
                placeholder="Cari mobil"
              />
              <div class="position-absolute wrapper_search text-center">
                <b-icon icon="search"></b-icon>
              </div>
            </div>
          </b-nav-item>
          <b-nav-item href="#" class="mt-2">
            <div class="hot_item text-center">
              HOT ITEMS
            </div>
          </b-nav-item>
          <router-link
            ta="div"
            :to="{ name: 'new-view' }"
            class="b-red button_auth ml-3"
          >
            <img
              src="@/assets/img/people.png"
              alt=""
              width="30"
              class="rounded-circle"
            />
            <span class="fs-12 text-white ml-2">CINDY YUVIA</span>
          </router-link>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      icon_nav: [
        { src: require("@/assets/img/red_car.png"), name: "Mobil" },
        { src: require("@/assets/img/home.png"), name: "Rumah" },
        { src: require("@/assets/img/head.png"), name: "Pendidikan" },
        { src: require("@/assets/img/truck.png"), name: "Truck" }
      ]
    };
  }
};
</script>
<style scoped>
.button_auth {
  height: 70px;
  padding: 10px;
  border-radius: 0 0 20px 20px;
}
.nav_bar_flex {
  height: 55px;
  line-height: 55px;
  box-shadow: 0 4px 20px rgba(149, 185, 193, 0.2);
}
.content_menu_list > li {
  list-style: none;
  font-weight: bold;
  border-bottom: 1px solid #d6d2d2;
}
.search_navbar {
  border: 1px solid #d6d2d2;
  height: 32px;
  border-radius: 16px;
}
.wrapper_search {
  line-height: 35px;
  top: 12px;
  right: 0;
  height: 32px;
  width: 65px;
  background: #b9babe;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
}
.hot_item {
  border: 2px solid #ff5e41;
  width: 100px;
  border-radius: 12px;
  height: 40px;
  line-height: 37px;
  color: #ff5e41;
}
.item_search {
  width: 65%;
}
</style>
